export default __webpack_public_path__ + "static/media/project3.ecd0d81e.png";